import { render, staticRenderFns } from "./StatusBulkCreate.vue?vue&type=template&id=ddbf5db4"
import script from "./StatusBulkCreate.vue?vue&type=script&lang=js"
export * from "./StatusBulkCreate.vue?vue&type=script&lang=js"
import style0 from "./StatusBulkCreate.vue?vue&type=style&index=0&id=ddbf5db4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports